import { getProxiedServiceUrl } from 'wmic-portals-url-js';
import { WMICJsonRPCService } from 'wmic-portals-transport-js';

export default class UsersProfileDetailsService {
    /**
     * Retrieves an accounts contact summary.
     *
     * @param {Object} authHeader additional headers to pass to the backend (e.g. auth)
     * @returns {Promise} the promise from the backend call
     * @memberof AccountBillingDetailsService
     */
    static getAccountsContactSummaries(authHeader = {}) {
        return WMICJsonRPCService.send(getProxiedServiceUrl('userProfileInfo'), 'getAccountsContactSummaries', [], authHeader);
    }

    /**
     * Retrieves an accounts contact summary.
     *
     * @param {Object} accountSummaryDTO an updated account summary DTO
     * @param {Object} authHeader additional headers to pass to the backend (e.g. auth)
     * @returns {Promise} the promise from the backend call
     */
    static updateAccountContactSummary(accountSummaryDTO, authHeader = {}) {
        return WMICJsonRPCService.send(getProxiedServiceUrl('userProfileInfo'), 'updateAccountContactSummary', [accountSummaryDTO], authHeader);
    }

    // eslint-disable-next-line camelcase
    static getContactSummary_WMIC(authHeader = {}) {
        return WMICJsonRPCService.send(getProxiedServiceUrl('userProfileInfo'), 'getContactSummary_WMIC', [], authHeader);
    }

    // eslint-disable-next-line camelcase
    static updateContactSummary(activitySummaryDTO, authHeader = {}) {
        return WMICJsonRPCService.send(getProxiedServiceUrl('userProfileInfo'), 'updateContactSummary', [activitySummaryDTO], authHeader);
    }

    // eslint-disable-next-line camelcase
    static getBankingInfoForProfile(accountNumber, publicId, authHeader = {}) {
        return WMICJsonRPCService.send(getProxiedServiceUrl('billingData'), 'getBankingInfoForProfile', [accountNumber, publicId], authHeader);
    }

    // eslint-disable-next-line camelcase
    static getAccountSummaryForProfile(authHeader = {}) {
        return WMICJsonRPCService.send(getProxiedServiceUrl('billingData'), 'getAccountSummaryForProfile', [], authHeader);
    }   
}